// extracted by mini-css-extract-plugin
module.exports = {"chatAnswerContainer":"ChatAnswer_chatAnswerContainer__womjZ","chatAnswer":"ChatAnswer_chatAnswer__aKF1K"};